import {CloseOutlined} from "@ant-design/icons";
import {ReactNode} from "react";
import "./panel.css";

interface PanelProps {
    isOpen: boolean;
    children: ReactNode | ReactNode[];
    onClose: () => void;
    width?: number;
    className?: string;
    darkenScreen?: boolean;
}

const PanelInner = ({ isOpen, children, onClose, width = 300, className }: PanelProps) => {
    return (
        <div className={`panel-container ${isOpen ? 'open' : ''} ${className}`} style={{ width: `${width}px`, right: `${-width}px`, transition: `all ${width/300 * 0.2}s ease-in-out`}}>
            <div className="close-button" onClick={onClose}><CloseOutlined /></div>
            <div className="panel-content">
                {children}
            </div>
        </div>
    );
}

const Panel = ({ isOpen, children, onClose, width = 300, className, darkenScreen = false }: PanelProps) => {
    if(darkenScreen) {
        return <>
            <PanelInner isOpen={isOpen} onClose={onClose} width={width} className={`${className} with-background`}>{children}</PanelInner>
            <div className={`panel-darken-background ${isOpen ? 'shown' : ''}`}></div>
        </>
    } else {
        return <PanelInner isOpen={isOpen} onClose={onClose} width={width} className={className}>{children}</PanelInner>;
    }
}

export default Panel;